
import { defineComponent } from "vue";
import SalesOrderOrderOverviewImport from "@/views/sales-order/order-overview/CommonImport.vue";
export default defineComponent({
  name: "sales-order-order-verification-import",
  components: { SalesOrderOrderOverviewImport },
});
